import { Button } from '@mui/material'
import * as React from 'react'
import workChat from './assets/work-chat.svg'
import logo from './assets/logo.png'
import { Link, useNavigate } from 'react-router-dom'
import './App.css'
import { SubmitHandler, useForm } from 'react-hook-form'
import { socket } from './fetchoptions'
import { RootState } from './app/store';
import { useSelector, useDispatch } from 'react-redux'
import { setProfile } from './features/usersSlice'
import makeId from './features/makeId'

interface Inputs {
	username: string
	roomId: string
	roomname: string
}

export default function NewRoom () {
	const [isCreate, setIsCreate] = React.useState(true);
	const navigate = useNavigate();
	React.useEffect(() => {
		socket.on('room-joined', (room) => {
			// console.log(room);
			navigate('/main')
		})
		socket.on('room-created', (room) => {
			// console.log(room);
			navigate('/main')
		})
		const queryString = window.location.search;
		const parameters = new URLSearchParams(queryString);
		const value = parameters.get('opt');
		if (value && value === "join")
		{
			setIsCreate(false);
		} else
		{
			setIsCreate(true);
		}
	}, [navigate])

	return (
		<div className='h-screen flex bg-slate-600 px-4 md:px-20 lg:px-36'>
			<div className="m-auto max-w-2xl">
				<nav className='pb-10 pt-2 '>
					<Link to="/" className='flex w-max'>
						<img src={logo} alt="logo" className="h-6 my-auto mr-2" />
						<span className='font-bold text-white text-xl font-serif'>QUICKROOM</span>
					</Link>
				</nav>
				<div className='bg-slate-50 transition duration-500 flex my-auto rounded-lg w-full'>
					<img className=' h-full bg-img hidden sm:block w-1/2 p-10 my-auto' src={workChat} alt="chat" />
					<div className='text-slate-600 p-4 sm:p-10 w-full sm:w-1/2 text-xs'>
						{isCreate ? <CreateRoom setIsCreate={setIsCreate} /> : <JoinRoom setIsCreate={setIsCreate} />}
					</div>
				</div>
			</div>
		</div>
	)
}


function CreateRoom ({ setIsCreate }: any) {
	const { register, formState: { errors }, handleSubmit } = useForm<Inputs>();
	const dispatch = useDispatch();

	const onSubmit: SubmitHandler<Inputs> = data => {
		const userId = makeId(6);
		dispatch(setProfile({ id: userId, username: data.username }));
		socket.emit(
			'create-room', {
			user: { id: userId, username: data.username },
			room: { id: makeId(7), name: data.roomname, createdBy: data.username }
		})
	};
	return (
		<form className='slide-left w-full' onSubmit={handleSubmit(onSubmit)}>
			<div className='mb-8'>
				<h3 className='text-2xl text-slate-500 font-serif font-bold'>Create Room</h3>
				<span onClick={() => setIsCreate(false)} className='my-auto lg:ml-auto text-xs text-blue-500 cursor-pointer'>Join Room instead?</span>
			</div>
			<label>Room Name</label>
			<input {...register("roomname", { required: true })} className='p-2 text-sm mb-1 mt-2 focus:border-green-500 transition border rounded w-full outline-none' />
			{errors.roomname && <span className='text-red-400'>Room name is required</span>} <br />
			<label className='mt-3 block'>Your username</label>
			<input  {...register("username", { required: true })} className='p-2 text-sm mb-1 mt-2 focus:border-green-500 transition border rounded w-full outline-none' />
			{errors.username && <span className='text-red-400'>Username field is required</span>}
			<Button type='submit' onClick={handleSubmit(onSubmit)} style={{ width: "100%", marginTop: "1.6rem" }} variant='contained'>Create</Button>
		</form>
	)
}

function JoinRoom ({ setIsCreate }: any) {
	const { register, formState: { errors }, handleSubmit } = useForm<Inputs>();
	let { profile } = useSelector((state: RootState) => state.user)
	const [message, setMessage] = React.useState(<></>);
	const dispatch = useDispatch();

	const handleSocket = React.useCallback(() => {
		socket.on("message", (message) => {
			if (message.notExist)
			{
				setMessage(<span className='text-red-400'>No active room match this Id</span>)

			} else if (message.memberAlready)
			{
				setMessage(<span className='text-red-400'>You are a member already, <Link to="/main" className='text-blue-500'>Check your rooms</Link></span>)
			}
		})
	}, [])



	React.useEffect(() => {
		handleSocket();

	}, [handleSocket])

	const onSubmit: SubmitHandler<Inputs> = data => {
		if (!profile.id) dispatch(setProfile({ id: makeId(6), username: data.username }));
		socket.emit('join-room', { user: profile, roomId: data.roomId })
	};
	return (
		<form className='slide-left' onSubmit={handleSubmit(onSubmit)}>
			<div className='mb-8'>
				<h3 className='text-2xl text-slate-500 font-serif font-bold'>Join Room	</h3>
				<span onClick={() => setIsCreate(true)} className='my-auto lg:ml-auto text-xs text-blue-500 cursor-pointer'>Create room</span>
			</div>
			{message} <br />

			<label>Room Id</label>
			<input {...register("roomId", { required: true })} className='p-2 text-sm mb-1 mt-2 focus:border-green-500 transition border rounded w-full outline-none' />
			{errors.roomId && <span className='text-red-400'>Room Id is required</span>} <br />
			<label className='mt-3 block'>Your username</label>
			<input  {...register("username", { required: true })} className='p-2 text-sm mb-1 mt-2 focus:border-green-500 transition border rounded w-full outline-none' />
			{errors.username && <span className='text-red-400'>Username field is required</span>}
			<Button type='submit' onClick={handleSubmit(onSubmit)} style={{ width: "100%", marginTop: "1.6rem" }} variant='contained'>Join</Button>
		</form>
	)
}